const BlurBackground = () => {
    return (
        <div className="blur-background"/>
    )
}

export default BlurBackground
